import classNames from 'classnames';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { iconSets } from '../../constants';
import {
  compose,
  defaultProps,
  mapProps,
  setPropTypes
} from 'recompose';

const Icon = ({ children, ...props }) => (
  <span {...props}>
    {children}
  </span>
);

export default compose(
  setPropTypes({
    icon: PropTypes.string,
    iconSet: PropTypes.string,
    iconSize: PropTypes.number
  }),
  defaultProps({
    iconSet: 'icon',
    iconSize: 1
  }),
  mapProps(({
    className,
    icon,
    iconSet,
    iconSize,
    ...props
  }) => ({
    ...props,
    className: classNames(
      fp.get(iconSet)(iconSets)(icon),
      {
        [`icon-x${iconSize}`]: iconSize > 1
      },
      className
    ),
    'aria-hidden': 'true'
  }))
)(Icon);



// WEBPACK FOOTER //
// ./src/containers/components/icon.js